<script setup lang="ts">
import { ref, watch } from 'vue'
import { useUserStore } from '@/stores/user'
import { useFormStore } from '@/stores/form'

const userStore = useUserStore()
const formStore = useFormStore()

const usernote = ref('')
const last5 = ref('')
const note = ref('')
const selectedPlan = ref<number | null>(null) // ✅改為數字

const firstPurchase = ref(true)
const ExPackagePrice = ref(2800)

const pricePerMonth = 800

const plans = [
  ...Array.from({ length: 12 }, (_, i) => {
    const months = i + 1
    return {
      label: `${months.toString().padStart(2, '0')}個月`,
      months,
      amount: months * pricePerMonth
    }
  }),
  { label: '24個月', months: 24, amount: 24 * pricePerMonth }
]

function gologinorvideo() {
  cleanUserInput()
  formStore.switchForm('login')
}

function cleanUserInput() {
  last5.value = ''
  note.value = ''
  selectedPlan.value = null
  firstPurchase.value = false
}

// ✅計算金額同步 UI
watch([selectedPlan, firstPurchase], ([newMonths, isFirst]) => {
  const plan = plans.find(p => p.months === newMonths)

  if (!plan) {
    note.value = ''
    return
  }

  const packageFee = isFirst ? ExPackagePrice.value : 0
  const total = plan.amount + packageFee
  note.value = `匯款金額：${total} 元`
})

async function doTransfer() {
  if (!selectedPlan.value) {
    alert('請選擇付款方案')
    return
  }

  if (last5.value.length !== 5) {
    alert('請正確填寫匯款帳號後五碼')
    return
  }

  const plan = plans.find(p => p.months === selectedPlan.value)
  const amount = plan?.amount ?? 0
  const totalAmount = firstPurchase.value ? amount + ExPackagePrice.value : amount

  await userStore.TransferInsert(
    userStore.account,
    `${selectedPlan.value}個月`,
    totalAmount,
    last5.value,
    note.value
  )

  cleanUserInput()
  alert('請稍後，系統作業中...')

  setTimeout(() => {
    alert('匯款登錄完成，如有任何問題請洽 Line 官方，感謝您。')
  }, 3000)

  formStore.switchForm('login')
}
</script>

<template>
  <div class="transfer-container">

    <h3>選擇付款方案</h3>
    <div class="firstbuy">
      <label style="color: red;">注意事項</label>
      <label>1.零配件請洽官方Line(鏡頭，伸展支架，掃碼槍)</label>
      <label>2.首購系統開通 + 4K鏡頭 + 支架，送掃碼槍優惠 ${{ ExPackagePrice }} 元</label>
      <label>3.非首購請取消勾選</label>
      <div style="margin-top:10px;">
        <input type="checkbox" id="firstPurchase" v-model="firstPurchase" />
        <label for="firstPurchase">
          首購鏡頭 + 開通費 $2800（月費：$900，經銷方案：$800）
        </label>
      </div>
    </div>

    <div class="form-group">
      <select v-model="selectedPlan" required style="width: 100%; padding: 10px; font-size: 16px;">
        <option :value="null" disabled>請選擇方案</option>
        <option v-for="plan in plans" :key="plan.months" :value="plan.months">
          {{ plan.label }}
        </option>
      </select>
    </div>

    <!-- ✅ 顯示金額 -->
    <div v-if="selectedPlan !== null">
      <p style="color: deeppink; font-size: larger;">
        {{ note }}
      </p>
    </div>

    <hr>
    <div class="backinfo">
      <h3>匯款帳戶</h3>
      <label>第一銀行 銀總代號 : 007</label>
      <label>戶名 : 虔智科技有限公司</label>
      <label>帳號 : 272-10-150846</label>
    </div>

    <hr>

    <h3>回報匯款資料 註!!!請匯款後填寫</h3>
    <div class="form-group">
      <label>用戶帳號</label>
      <input type="text" v-model="userStore.account" :disabled="userStore.isLoggedIn"
        placeholder="請輸入帳號 E-Mail 務必檢查" />

      <label>匯款帳號後五碼</label>
      <input v-model="last5" type="text" maxlength="5" required />

      <label>系統備註</label>
      <textarea v-model="note" rows="3" disabled></textarea>

      <label>用戶備註</label>
      <textarea v-model="usernote" rows="5" placeholder="可選填"></textarea>
    </div>

    <button :disabled="!selectedPlan || last5.length !== 5" @click="doTransfer">
      填寫送出
    </button>

    <button @click="gologinorvideo">返回</button>
  </div>
</template>

<style scoped>
button:disabled {
  background-color: grey;
  cursor: not-allowed;
}

h3 {
  color: deeppink;
}

#firstPurchase {
  transform: scale(1.5);
  margin: 10px;
}

.transfer-container {
  padding: 20px;
  max-width: 500px;
  margin: auto;
  border: 1px solid deeppink;
  border-radius: 8px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 6px;
  font-weight: bold;
}

input,
textarea,
select {
  border-radius: 10px;
  background-color: black;
  color: white;
  font-size: 18px;
  margin: 10px 0;
  width: 400px;
  padding: 5px;
}

button {
  background-color: deeppink;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin: 5px;
}
</style>
